import angular from 'angular';
/* Module Imports */
import reportParametersModule from './reportparameters/reportParameters.module';

/* Additional Imports */
import DatapointMultiPickerController from './datapointspicker/datapoint.multi.picker.controller';
import ReportsDetailController from './reports.detail.controller';

const reportViewModule = angular
  .module('app.reportview', ['ui.bootstrap', 'ui.router', 'gettext', reportParametersModule])
  .controller('DatapointMultiPickerController', DatapointMultiPickerController)
  .controller('ReportsDetailController', ReportsDetailController);

export default reportViewModule.name;
